import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cedfe068&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=cedfe068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedfe068",
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseUiBreadcrumb: require('/var/www/html/intelli.com.br/components/base/ui/Breadcrumb.vue').default,BaseUiMenu: require('/var/www/html/intelli.com.br/components/base/ui/Menu.vue').default,BaseUiVideos: require('/var/www/html/intelli.com.br/components/base/ui/Videos.vue').default,BaseUiFiles: require('/var/www/html/intelli.com.br/components/base/ui/Files.vue').default,BaseUiCardPublication: require('/var/www/html/intelli.com.br/components/base/ui/CardPublication.vue').default,BaseUiNewsletter: require('/var/www/html/intelli.com.br/components/base/ui/Newsletter.vue').default})
